<template>
  <div
    :class="[
      wide ? 'rounded-b-wide' : 'rounded-b-tight',
      {
        'border-hover-active': hoverHighlight,
        'cursor-pointer': !!to
      }
    ]"
    @click="handleClick"
  >
    <!-- eslint-disable max-len -->
    <div
      class="flex items-center shadow-lg"
      :class="[
        { 'flex-col': center },
        bgGray ? 'bg-gray border-t-2 border-r-2 border-l-2 border-hover border-theme1' : 'bg-theme1',
        wide ? 'rounded-t-wide p-8 md:p-16' : 'rounded-t-tight p-8',
        !content && (wide ? 'rounded-wide' : 'rounded-tight')
      ]"
    >
      <CoreIcon
        class="h-16"
        :icon="icon"
        :black="bgGray"
      />
      <h2
        class="text-2 md:text-1 leading-none"
        :class="[
          { 'text-white': !bgGray },
          center ? 'mt-8' : 'ml-8'
        ]"
        v-text="title"
      />
    </div>
    <div
      v-if="content"
      class="bg-gray border-b-2 border-r-2 border-l-2 border-hover border-theme1 shadow-lg flex flex-col flex-grow"
      :class="[wide ? 'rounded-b-wide p-8 md:p-16' : 'rounded-b-tight p-8', { 'pt-0': bgGray}]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CoreCard',

  props: {
    center: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    wide: {
      type: Boolean,
      default: false,
    },
    to: {
      type: [Object, String],
      default: null,
    },
    bgGray: {
      type: Boolean,
      default: false,
    },
    hoverHighlight: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    content() {
      return !(typeof this.$slots.default === 'undefined');
    },
  },

  methods: {
    handleClick() {
      if (this.to) {
        if (typeof this.to === 'string') window.open(this.to, '_blank');
        if (typeof this.to === 'object') this.$router.push(this.to);
      }
    },
  },
};
</script>

<style scoped>
.pt-0 {
  padding-top: 0;
}

.border-hover-active .border-hover {
  transition-property: border-color;
  transition-duration: var(--transition-short);
  transition-timing-function: var(--transition-ease);
  border-color: theme('colors.gray');
}

.border-hover-active:hover .border-hover {
  border-color: theme('colors.theme1');
}

</style>
